const angular = require('angular');
const app = angular.module('learn-directives');
/**
 * Defines the google calendar component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.directive('googleCalendar', ['Application', 'Authorization', 'GcalResource', function (Application, Authorization, GcalResource) {
  return {
    restrict: 'E',
    replace: true,
    scope: {},
    template: require('../../templates/directives/google-calendar.html'),
    controller: ['$scope', function ($scope) {
      var self = this;
      self.user = Authorization.getAuthToken().user;

      if (!Application.features.flags().enable_new_gcal_calendar) {
        Application.navigation.goToHome();
      }

      self.addToCalendar = function() {

        GcalResource.gcalPermissionLink({user: self.user._id}, {}).$promise
        .then(function(data) {
          if (data && data.redirect_url) {
            Application.storage.put('gcal_redirect', {path: Application.navigation.getPath(), query: Application.navigation.getUrlParameters()});
            window.location.href = data.redirect_url;
          }
        })
      };

    }],
    controllerAs: 'gcal'
  };
}]);